const R2_ASSET_BASE = 'https://frontend-cdn.perplexity.ai/_agi_assets';
// Mutable min-version refresh file, intentionally outside the immutable `_agi_assets/` catalog.
export const MIN_VERSION_REFRESH_URL = 'https://frontend-cdn.perplexity.ai/_min-version-refresh/min-version-refresh.json';
/** Returns the CDN URL for an R2 asset. Catalog membership is validated by lint. */
export function r2Asset(path) {
    return `${R2_ASSET_BASE}/${path}`;
}
//# sourceMappingURL=r2Asset.js.map